import "core-js/modules/es6.array.map";
import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.define-property";
import React, { useMemo, useCallback } from 'react';

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var MapToComponents = function MapToComponents(_ref) {
  var getKey = _ref.getKey,
      getType = _ref.getType,
      list = _ref.list,
      map = _ref.map,
      meta = _ref.meta,
      _ref$mapDataToContext = _ref.mapDataToContext,
      mapDataToContext = _ref$mapDataToContext === void 0 ? {} : _ref$mapDataToContext,
      _ref$mapDataToProps = _ref.mapDataToProps,
      mapDataToProps = _ref$mapDataToProps === void 0 ? {} : _ref$mapDataToProps,
      _ref$default = _ref["default"],
      defaultMapping = _ref$default === void 0 ? function (_ref2) {
    var type = _ref2.type;
    throw new Error("Could not find a component mapping for type \"".concat(type, "\""));
  } : _ref$default,
      defaultMapDataToContext = _ref.defaultMapDataToContext,
      defaultMapDataToProps = _ref.defaultMapDataToProps;
  var keys = useMemo(function () {
    return list.map(getKey);
  }, [list, getKey]);
  var types = useMemo(function () {
    return list.map(getType);
  }, [list, getType]);
  var comps = useMemo(function () {
    return types.map(function (type) {
      return map[type] || defaultMapping;
    });
  }, [types, map, defaultMapping]);
  var gatherData = useCallback(function (index) {
    return {
      list: list,
      keys: keys,
      types: types,
      comps: comps,
      map: map,
      meta: meta,
      index: index,
      data: list[index],
      key: keys[index],
      type: types[index],
      Comp: comps[index],
      previousData: list[index - 1],
      previousKey: keys[index - 1],
      previousType: types[index - 1],
      PreviousComp: comps[index - 1],
      nextData: list[index + 1],
      nextKey: keys[index + 1],
      nextType: types[index + 1],
      NextComp: comps[index + 1]
    };
  }, [comps, keys, types, meta, list, map]);
  var contexts = useMemo(function () {
    return list.map(function (_, index) {
      var fn = mapDataToContext[types[index]] || defaultMapDataToContext;
      return fn ? fn(gatherData(index)) : {};
    });
  }, [gatherData, list, mapDataToContext, types]);
  var gatherDataForMapDataToProps = useCallback(function (index) {
    return _objectSpread2({}, gatherData(index), {
      contexts: contexts,
      context: contexts[index],
      previousContext: contexts[index - 1],
      nextContext: contexts[index + 1]
    });
  }, [gatherData, contexts]);
  var props = useMemo(function () {
    return list.map(function (_, index) {
      var fn = mapDataToProps[types[index]] || defaultMapDataToProps;
      return fn ? fn(gatherDataForMapDataToProps(index)) : {};
    });
  }, [gatherDataForMapDataToProps, list, mapDataToProps, types]);
  return props.map(function (mappedProps, index) {
    return React.createElement(comps[index], _objectSpread2({
      key: keys[index]
    }, mappedProps));
  });
};

export default MapToComponents;